import { Component, Input, OnInit } from '@angular/core';
import { TaskDetailsObject } from 'src/app/models/tasks/tasks-details/task-details.model';
import { ErrorPropertiesObject } from 'src/app/models/tasks/tasks-properties/error-properties/error-properties-object.model';
@Component({
  selector: 'app-error-properties',
  templateUrl: './error-properties.component.html',
  styleUrls: ['./error-properties.component.css']
})
export class ErrorPropertiesComponent implements OnInit {

  errorProperties: ErrorPropertiesObject;
  @Input() taskDetails: TaskDetailsObject;

  constructor() {

  }

  ngOnInit() {
    this.errorProperties = this.taskDetails.getProperties().getErrorProperties();
  }
}
